// extracted by mini-css-extract-plugin
export default {"wrapper":"Confirm_wrapper__DqNiC","container":"Confirm_container__4g1NR","content":"Confirm_content__Isnds","buttons":"Confirm_buttons__PX7YF"};